export default __webpack_public_path__ + "images/AY.a7d45fc.png";